var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.order)?_c('span',{class:['caret-icon', { 'caret-up': _vm.order === 'ascending' }]},[_c('SvgIcon',{attrs:{"name":"chevron-down"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }